module.exports = __webpack_public_path__ + "media/components/src/assets/images/heading/heading_1-52319a442434574eec9444f3cae58418.png";